import {PreviousHistoryTabs, useStyles} from "../../Utils/Menu/ReusableDoctorTabs";
import {
    PreviousAntenatal,
    PreviousClinicalNotes, PreviousDiagnosis, PreviousLabResults, PreviousPrescription,
    PreviousProcedure, PreviousRadiology,
    PreviousTriage,
} from "./medicalComponents";
import {formatDateTime} from "../../Utils/ConvertDate";
import {PreviousVisitContainer} from "../../Utils/Lists/PreviousVisitContainer";
import Tooltip from "@material-ui/core/Tooltip";
import Grid from "@material-ui/core/Grid";
import React from "react";
import styled from "@emotion/styled/macro";
import axios from "axios";
import {config} from "../../../Helpers/env";
import {logoutErrorMessage} from "../../../Helpers/ErrorMessages";
import CustomDialog from "../../Utils/Dialogs/CustomDialog";
import {VisitHistory} from "./VisitHistory";

export const P = styled.p({
    margin: 0,
});

export const VisitType = styled(P)({
    fontWeight: 700,
});

export const VisitDate = styled(P)({
    fontSize: "13px",
});



export const PreviousGynVisits = ({visits, setVisits, actions}) => {

    const tabs = [{value:'Triage', component:'triage',isActive:true},{value:' Clinical Notes', component:'notes'},
        {value:'Procedure', component:'procedure'},
        {value:'Laboratory', component:'lab'},{value:'Radiology', component:'radiology'},
        {value:'Diagnosis', component:'diagnosis'},{value:'Prescription', component:'prescription'}]

    const [openPrint, setOpenPrint] = React.useState(false)
    const [visit, setVisit] = React.useState({})

    const handleOpenVisit =  (v_id) => {
        const formData = new FormData();
        formData.append('visit_id', v_id);
        axios.post(`${config.smsUrl}/cdoctor/get_all_patient_treatment_details`, formData).then(res => {
            const data = res.data;
            const details = !data ? {} : data;
            const {lab_result,scan_result, diagnosis,prescription,other_medicine,exam_notes,triage} = details
            const presc = prescription ? prescription : [];
            const others = other_medicine ? other_medicine : [];
            const procedure = details.procedure ? details.procedure : []
            const other_meds = others.filter(item=>Boolean(item));
            const medicationArr = [...presc, ...other_meds];
            const labArr = lab_result?.map(item=>({...item, open:true}))
            const scanArr = scan_result?.map(item=>({...item, open:true}))
            const arr = visits.map((item)=> {
                if (item.visit_id === v_id) {
                    return {
                        ...item, components: tabs, activeItem: 'triage', open: !item.open,
                        labResults: labArr,
                        radiologyResults: scanArr,
                        patientDiagnosis: diagnosis,
                        medication: medicationArr,
                        patientTriage: triage,
                        procedure,
                        clinicalNotes: exam_notes.map(note=>({
                            ...note, openNote:true
                        }))
                    }
                }
                return item
            })
            setVisits(arr)
        }).catch(err => {
            logoutErrorMessage(err, null, actions)
        })
    }

    const handleOpenResults = (visit_id,index,arr,item_name) =>{
        const visitArr = visits.map((item)=>{
            if (item.visit_id === visit_id){
                const openedArr = arr.map((child, idx)=>{
                    if(idx === index){
                        return {...child, open:!child.open}
                    }else {
                        return child
                    }
                })
                return {...item, [item_name]:openedArr}
            }
            return item
        })
        setVisits(visitArr)
    }

    const handleClickComponent = (index, item_name, v_id) => {
        const arr = visits.map(item=>{
            if(item.visit_id === v_id){
                return  {...item, activeItem:item_name, components: item?.components?.map((component, idx)=>{
                        if (idx === index){
                            return {...component, isActive:true}
                        }
                        return {...component, isActive:false}
                    })}
            }
            return item
        })
        setVisits(arr)
    }

    const handleOpenNote = (v_id,notes_id) => {
        const arr = visits.map(item=>{
            if(item.visit_id === v_id){
                return  {...item,  clinicalNotes: item?.clinicalNotes?.map((note, idx)=>{
                        if (note.examination_notes_id === notes_id){
                            console.log('Notes details',notes_id)
                            return {...note, openNote:!note.openNote}
                        }
                        return note
                    })}
            }
            return item

        })
        setVisits(arr)
    }


    const classes = useStyles();
    return (
        <div>

            <CustomDialog
                open={openPrint}
                handleClose={()=>setOpenPrint(false)}
                title="Print Preview"
                maxWidth="lg"
                isContentOverflow={true}
                isPaperStyle={true}
            >
                <VisitHistory {...{actions, visit}}/>
            </CustomDialog>
            {visits.map((item, index) => {
                    const type = {
                        1: "OPD Visit",
                        2: "IPD Visit",
                    };
                    const visitTitle = (
                        <>
                            <VisitType>{type[item.patient_type]}</VisitType>
                            <VisitDate>
                                Date:{" "}
                                <strong>
                                    {item.begin_datetime ? formatDateTime(item.begin_datetime) : ""}
                                </strong>
                            </VisitDate>
                        </>
                    );

                    const tab = {
                        triage: <PreviousTriage patientTriage={item?.patientTriage}/>,
                        notes: (
                            <PreviousClinicalNotes
                                clinicalNotes={item?.clinicalNotes}
                                visit_id={item.visit_id}
                                handleOpen={handleOpenNote}
                            />
                        ),
                        procedure: <PreviousProcedure procedure={item?.procedure}/>,
                        lab: (
                            <PreviousLabResults
                                handleOpenResults={handleOpenResults}
                                labResults={item?.labResults}
                                visit_id={item.visit_id}
                                isDoctor={true}
                            />
                        ),
                        radiology: (
                            <PreviousRadiology
                                radiologyResults={item?.radiologyResults}
                                handleOpenResults={handleOpenResults}
                                visit_id={item.visit_id}
                            />
                        ),
                        diagnosis: (
                            <PreviousDiagnosis patientDiagnosis={item?.patientDiagnosis}/>
                        ),
                        prescription: <PreviousPrescription medication={item?.medication}/>,
                        antenatal: (
                            <PreviousAntenatal
                                chronic_illness_dt={item?.chronic_illness_dt}
                                antenatal_data={item?.antenatal_data}
                            />
                        ),
                    };

                    return (
                        <PreviousVisitContainer
                            open={item.open}
                            key={item.visit_id}
                            name={visitTitle}
                            idx={index}
                            handleOpen={() => handleOpenVisit(item.visit_id)}
                            button={
                                <Tooltip title="Print">
                                    <button
                                        onClick={() => {
                                            setOpenPrint(true)
                                            setVisit(item)
                                        }}
                                        className="btn btn-sm sms-amber-btn"
                                    >
                                        Print
                                    </button>
                                </Tooltip>
                            }
                        >
                            <Grid container spacing={0}>
                                <Grid
                                    item
                                    xs={6}
                                    md={3}
                                    sm={2}
                                    lg={2}
                                    classes={{item: `${classes.item} ${classes.tabItem}`}}
                                >
                                    {item?.components
                                        ?.filter((comp) => Boolean(comp))
                                        .map((comp, idx) => (
                                            <PreviousHistoryTabs
                                                item={comp}
                                                key={idx}
                                                handleClick={() =>
                                                    handleClickComponent(idx, comp.component, item.visit_id)
                                                }
                                            />
                                        ))}
                                </Grid>
                                <Grid
                                    item
                                    sm={10}
                                    xs={6}
                                    md={9}
                                    lg={10}
                                    classes={{item: classes.item2}}
                                >
                                    <div className="p-3">{tab[item?.activeItem]}</div>
                                </Grid>
                            </Grid>
                        </PreviousVisitContainer>
                    );
                })};
        </div>
    )
};